import React, { useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { setToken } from '../api';
import { Card, GradientText, glowBackground, LogoMark } from '../ui';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/auth/login', { username: username.trim(), password });
      setToken(res.data.token);
      onLogin();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Неверный логин или пароль');
      } else {
        setError('Не удалось подключиться к серверу');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: glowBackground(), p: 2, position: 'relative' }}>
      <Card sx={{ p: 4, width: 380, maxWidth: '100%', borderRadius: '16px', position: 'relative', zIndex: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Box sx={{ mb: 1.75 }}>
            <LogoMark size={52} />
          </Box>
          <Typography sx={{
            fontFamily: '"JetBrains Mono", monospace', fontSize: 10.5, fontWeight: 500,
            letterSpacing: '0.2em', textTransform: 'uppercase', color: 'text.secondary', mb: 0.75,
          }}>
            Secure access
          </Typography>
          <GradientText sx={{ fontSize: 26, fontWeight: 600, letterSpacing: '-0.03em', display: 'block' }}>
            Admetrix
          </GradientText>
          <Typography sx={{ fontSize: 13.5, color: 'text.secondary', mt: 0.5 }}>Вход в приложение</Typography>
        </Box>

        <form onSubmit={submit}>
          <TextField label="Логин" fullWidth autoFocus value={username} onChange={(e) => setUsername(e.target.value)} sx={{ mb: 2 }} />
          <TextField label="Пароль" type="password" fullWidth value={password} onChange={(e) => setPassword(e.target.value)} sx={{ mb: 2 }} />
          {error && <Alert severity="error" sx={{ mb: 2, borderRadius: '6px' }}>{error}</Alert>}
          <Button type="submit" variant="contained" fullWidth disabled={loading} sx={{ py: 1.2, fontSize: 15 }}>
            {loading ? 'Вход…' : 'Войти'}
          </Button>
        </form>
      </Card>
    </Box>
  );
}
